import { useEffect, useState } from 'react';
import { useUser } from '@clerk/clerk-react';

import {
  autoFinalizeMicrosoftMailboxIfGranted,
  computeMicrosoftMailState,
} from '../../utils/authUtils';
import { findClerkExternalAccount } from 'clerk-provider-config';
import LoadingSpinner from '../Shared/LoadingSpinner';

const MicrosoftMailboxBootstrap = ({ children }) => {
  const { isLoaded, user } = useUser();
  const [bootstrappedUserId, setBootstrappedUserId] = useState(null);

  useEffect(() => {
    let active = true;

    if (!isLoaded) {
      setBootstrappedUserId(null);
      return () => {
        active = false;
      };
    }

    if (!user) {
      setBootstrappedUserId('signed-out');
      return () => {
        active = false;
      };
    }

    if (!findClerkExternalAccount(user, 'microsoft')) {
      setBootstrappedUserId(user.id);
      return () => {
        active = false;
      };
    }

    setBootstrappedUserId(null);

    const finalizeMailbox = async () => {
      try {
        const state = await computeMicrosoftMailState(user);
        await autoFinalizeMicrosoftMailboxIfGranted({ state });
      } catch (error) {
        console.error('[MicrosoftMailboxBootstrap] mailbox bootstrap failed:', error);
      } finally {
        if (active) setBootstrappedUserId(user.id);
      }
    };

    finalizeMailbox();

    return () => {
      active = false;
    };
  }, [isLoaded, user]);

  if (!isLoaded || (user && bootstrappedUserId !== user.id)) {
    return <LoadingSpinner />;
  }

  return children;
};

export default MicrosoftMailboxBootstrap;
